/* Le cambia el responsable al negocio  (Deal)

Autor: Benjamín León
Fecha: 2025-01-02
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlDealAssign } from './connectionData.tsx'
const apiUrl = makeUrlDealAssign()

const useDealAssign = () => {
  const [dealAssignError, setDealAssignError] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const dealAssign = async (id: string, profileId: string) => {
    setLoading(true)

    try {
      await customPost(apiUrl, { _id: id, profileId: profileId })
      setDealAssignError(null)
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setDealAssignError(err)
      } else {
        setDealAssignError(new Error('An unknown error occurred'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { dealAssignError, loading, dealAssign }
}
export default useDealAssign
